import React from 'react';
import { useAppSelector } from 'src/services/redux/app/store';
import { KTSVG } from 'src/_metronic/helpers';

/**
 * Firma onay durumunu gösteren uyarı bandı
 * Header'ın üstünde görünür
 */
export const CompanyApprovalAlert: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);
  const company = user?.company;

  // Eğer firma onaylanmışsa hiçbir şey gösterme
  if (!company || company.approval_status === 'approved' || company.is_approved === true) {
    return null;
  }

  // Uyarı türüne göre renk ve mesaj belirleme
  const getAlertConfig = () => {
    switch (company.approval_status) {
      case 'pending':
        return {
          bgColor: 'bg-warning',
          textColor: 'text-dark',
          icon: '/media/icons/duotone/Code/Warning-2.svg',
          title: 'Onay Bekliyor',
          message: 'Firmanız admin onayı beklemektedir. Onay sürecinde tüm bilgilerinizi ekleyebilir ve güncelleyebilirsiniz.',
        };
      case 'rejected':
        return {
          bgColor: 'bg-danger',
          textColor: 'text-white',
          icon: '/media/icons/duotone/Code/Error-circle.svg',
          title: 'Başvuru Reddedildi',
          message: company.rejection_reason || 'Firmanızın başvurusu reddedildi. Lütfen eksiklikleri tamamlayıp tekrar başvurunuz.',
        };
      case 'suspended':
        return {
          bgColor: 'bg-danger',
          textColor: 'text-white',
          icon: '/media/icons/duotone/Code/Stop.svg',
          title: 'Hesap Askıya Alındı',
          message: company.rejection_reason || 'Firmanız askıya alınmıştır. Detaylı bilgi için destek ekibiyle iletişime geçiniz.',
        };
      default:
        return null;
    }
  };

  const config = getAlertConfig();
  if (!config) return null;

  return (
    <div
      className={`${config.bgColor} ${config.textColor} py-2 px-4 d-flex align-items-center justify-content-between flex-wrap`}
      style={{
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        minHeight: '50px',
      }}
    >
      <div className="d-flex align-items-center flex-grow-1">
        <KTSVG
          path={config.icon}
          className={`svg-icon-2x me-3 ${config.textColor}`}
        />
        <div className="flex-grow-1">
          <div className="fw-bold fs-6 mb-0">{config.title}</div>
          <div className="fs-7 opacity-75" style={{ maxWidth: '700px' }}>
            {config.message}
          </div>
        </div>
      </div>

      {company.approval_status === 'pending' && (
        <div className="d-flex align-items-center ms-3">
          <span className="badge badge-light-dark fs-7 px-3 py-2 d-flex align-items-center">
            <i className="bi bi-hourglass-split me-1"></i>
            <span>Onay Bekleniyor</span>
          </span>
        </div>
      )}

      {(company.approval_status === 'rejected' || company.approval_status === 'suspended') && (
        <div className="d-flex align-items-center ms-3">
          <span className="badge badge-light-danger fs-7 px-3 py-2 d-flex align-items-center">
            <i className="bi bi-exclamation-triangle-fill me-1"></i>
            <span>İşlem Gerekli</span>
          </span>
        </div>
      )}
    </div>
  );
};
